import { getDevices } from '@web-ui-kit/hooks.use-media-query'
import spaces from '@web-ui-kit/spaces/dist'
import { styled } from 'styled-components'

import { DEVICE_SIZE } from 'utils/constants'

const { SMALL, LARGE } = getDevices()

export const AppContainer = styled.div`
  align-content: stretch;
  align-items: stretch;
  background-color: var(--background-gray);
  display: flex;
  flex-direction: column;
  height: fit-content;
  justify-items: center;
  min-height: 100vh;
  position: relative;
  width: auto;
`

export const Main = styled.div`
  height: 100%;
  order: 2;
  overflow: auto;
`

export const TopBar = styled.div`
  order: 1;
`

export const Layout = styled.div`
  align-content: flex-start;
  display: ${({ $fullScreen }) => ($fullScreen ? 'block' : 'grid')};
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 1fr;
  grid-template-areas:
    'header'
    'content'
    'footer';
  min-height: 100vh;
  justify-content: center;
  @media (${LARGE}) {
    grid-template-columns: ${({ $showSidebar }) =>
      $showSidebar ? '3.5rem 1fr' : '0rem 1fr'};
    grid-template-areas:
      'nav header'
      'nav content'
      'nav footer';
  }
`

export const MainContainer = styled.main`
  box-sizing: border-box;
  grid-area: content;
  height: 100%;
  margin: 0 auto;
  max-width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : '1192px')};
  padding: ${({ $isFullWidth }) =>
    $isFullWidth ? '0' : `${spaces.XL} ${spaces.M}`};
  position: relative;
  width: 100%;

  > ul,
  > div {
    max-width: ${({ $isFullWidth, $isFullScreen }) => {
      if ($isFullScreen && $isFullWidth) {
        return 'none'
      }
      if ($isFullWidth) {
        return 'calc(100vw - 4rem);'
      }
      return '1192px'
    }};
  }

  ${({ $isFullWidth }) =>
    !$isFullWidth &&
    `
    @media (max-width: ${DEVICE_SIZE.LAPTOP_S}) {
      > ul {
        max-width: 100%;
      }
    }  

    @media (${SMALL}) {
      padding: ${spaces.XL} ${spaces.L};
    } 
  `};
`
